export default __webpack_public_path__ + "static/media/cube.816a9bf1.jpg";